/** ========================================================================= *\
 * @config
 * ========================================================================== */

// World configuration
export const WORLD_LENGTH = 20000;
export const FLOOR_HEIGHT = 40;
export const PIXEL_METERS = 2400; // How many pixels = 100m

// Visual configuration
export const MARKER_SIZE = { W: 80, H: 30 }
export const BACKGROUND_DENSITY = 600; // Smaller number is denser
export const HUD_PADDING = 24; // Padding from edges
export const FLOOR_COLOR = 0xF8B133;
export const MARKER_CONTAINER_HEIGHT = 40;

// Gameplay configuration
export const ENEMY_FREQUENCY = 450; // Smaller number is more frequent
export const LIVES = 3;
export const JUMP_VELOCITY = 900; // Higher number is higher
export const FLAPPY_BIRD_MODE = false;
export const SPEED = 7.5;
export const MAXSPEED = 30;
export const MAXCREATEENEMY = 900;
export const LOWCREATEENEMY = 1500;

//Power bar configuration
export const MAXCREATEPOWER = 6000;
export const LOWCREATEPOWER = 10000;


// WEBPACK FOOTER //
// ./js/config.js